import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {StorageService} from '../../service/storage.service';
import {SessionService} from '../../service/session.service';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-screen-resolution',
    templateUrl: './screen-resolution.component.html',
    styleUrls: ['./screen-resolution.component.css']
})
export class ScreenResolutionComponent implements OnInit {
    @ViewChild('canvas', {static: true})
    canvas: ElementRef<HTMLCanvasElement>;
    private ctx: CanvasRenderingContext2D;

    rectangle = new Rectangle();

    ccHeight = 53.98;
    ccWidth = 85.60;

    showContinue = false;

    constructor(private storage: StorageService,
                private device: DeviceDetectorService,
                private router: Router,
                private sessionService: SessionService) { }

    ngOnInit(): void {
        this.canvas.nativeElement.height = screen.height * 0.6; //this.canvas.nativeElement.offsetHeight;
        this.canvas.nativeElement.width = screen.width; //this.canvas.nativeElement.offsetWidth;
        this.ctx = this.canvas.nativeElement.getContext('2d');
    }

    canvasClick(event) {
        this.showContinue = false;

        const rect = this.canvas.nativeElement.getBoundingClientRect();
        const x = event.clientX;
        const y = event.clientY;

        if (!this.rectangle.startX) {
            this.rectangle.startX = x;
            this.rectangle.startY = y;
        } else if (!this.rectangle.endX) {
            this.rectangle.endX = x;
            this.rectangle.endY = y;
            this.calculateScreenSize();
        } else {
            this.rectangle = new Rectangle();
            this.rectangle.startX = x;
            this.rectangle.startY = y;
        }
    }

    drawRectangle(x, y, width, height) {
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);

        this.ctx.beginPath();
        this.ctx.fillStyle = 'red';
        this.ctx.stroke();
        this.ctx.fillRect(x, y, width, height);
    }

    calculateScreenSize() {
        const height = this.rectangle.endY - this.rectangle.startY;
        const width = this.rectangle.endX - this.rectangle.startX;
        console.log(width)
        console.log(width/38)

        const screenHeight = screen.height * this.ccHeight / height;
        const screenWidth = screen.width * this.ccWidth / width;
        console.log(window.screen.width * window.devicePixelRatio)
        this.storage.setCircleWidth(screen.width / screenWidth * 70);
        // alert('Height: ' + screenHeight + '. Width: ' + screenWidth);

        this.showContinue = true;
    }

    @HostListener('document:mousemove', ['$event'])
    onMouseMove(event) {
        if (this.rectangle.startX && !this.rectangle.endX) {
            const x = this.rectangle.startX;
            const y = this.rectangle.startY;

            const rect = this.canvas.nativeElement.getBoundingClientRect();
            this.drawRectangle(x, y, event.clientX - x, event.clientY - y);
        }
    }

    continueButton() {
        var canvas = document.getElementById("canvas");
        var ctx = this.canvas.nativeElement.getContext('2d');
        console.log("REAL CUADRADO")
        console.log(ctx)
        console.log(this.rectangle.endY, this.rectangle.startY)
        console.log(this.rectangle.endX, this.rectangle.startX)
        const cardWidth = 3.375;
        const pixels = this.rectangle.endY - this.rectangle.startY;
        console.log(pixels)
        console.log(this.canvas.nativeElement.getBoundingClientRect())
        console.log(pixels / cardWidth) //pixel desnity antigua
        console.log(screen.width + 'x' + screen.height)
        console.log(document.getElementById('dpi').getBoundingClientRect())
        var dpi_x = document.getElementById('dpi').offsetWidth;
        var dpi_y = document.getElementById('dpi').offsetHeight;
        console.log("-------DPI-------")
        console.log(dpi_x)
        console.log(dpi_y)
        var width = screen.width / dpi_x;
        var height = screen.height / dpi_y;
        console.log("-------INCHES-------")
        console.log(width)
        console.log(height)
        console.log("-------CM-------")
        console.log(width*2.54)
        console.log(height*2.54)


        const data = {
            browser: this.device.browser,
            version: this.device.browser_version,
            op_system: this.device.os,
            op_system_version: this.device.os_version,
            screen_resolution: screen.width + 'x' + screen.height,
            pixel_density_h: dpi_y,
            pixel_density_w: dpi_x,
            user_agent: this.device.userAgent
        };
        console.log(data);

        this.sessionService.addSession(data).then(resp => {
            console.log(resp);
            if (resp.status === 200) {
                // this.router.navigate(['/']);
            }
        }).catch(e => {
            console.log(e);
            if (e.status === 401) {
                console.log('Invalid Password');
            }
        });
    }
}

class Rectangle {
    startX: number;
    startY: number;
    endX: number;
    endY: number;
}
